import React from 'react';
import QuizButton from './quiz-button';

export default function QuestionContent(props: Props) {
  const { isPortrait, imageSize, style, challenge, selectedAnswer, onAnswerClick } = props;
  const css = {
    height: isPortrait ? '' : imageSize.height,
    background: style.background.forTextContent,
    color: style.textColor,
  };

  return (<div className="questionContent" style={css}>
    <div className="questionText">
        {challenge.question.text}
    </div>
    <div
      className="answerButtons"
      data-count={challenge.answers.length}
    >
        {
            challenge.answers.map((answer, i) => {
                return <QuizButton
                  buttonColors={style.buttonColors}
                  answer={answer}
                  key={i}
                  answerIndex={i}
                  selected={answer === selectedAnswer}
                  showCorrectAnswer={props.showCorrectAnswer}
                  onClick={() => onAnswerClick(answer)}
                />
            })
        }
    </div>
  </div>);
}



// WEBPACK FOOTER //
// ./src/campaign/challenges/quiz/question-content.jsx